import { render } from "./StockTransfer.vue?vue&type=template&id=5726ad78&scoped=true"
import script from "./StockTransfer.vue?vue&type=script&lang=js"
export * from "./StockTransfer.vue?vue&type=script&lang=js"

import "./StockTransfer.vue?vue&type=style&index=0&id=5726ad78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5726ad78"]])

export default __exports__